import React, { useEffect, useState } from 'react';

const TableContext = React.createContext();

export function useTable() {
    const context = React.useContext(TableContext);
    if (!context) {
        throw new Error('useTable must be used within a TableProvider');
    }
    return context;
}

export function TableProvider({ API_URL, CLIENT_CONTENT_URL, children }) {

    const [endpoint, setEndpoint] = useState(API_URL);
    const [contentEndpoint, setContentEndpoint] = useState(CLIENT_CONTENT_URL);

    const contextValue = {
        API_URL: endpoint,
        CLIENT_CONTENT_URL: contentEndpoint
    };
    useEffect(() => {
        setEndpoint(API_URL);
        setContentEndpoint(contentEndpoint);
    }, [API_URL]);

    if (!API_URL) {
        console.warn('TableProvider is not used with an API_URL.');
    }

    return (
        <TableContext.Provider
            value={contextValue}
        >
            {children}
        </TableContext.Provider>
    );
}
